import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-circular-progress-bar',
  templateUrl: './circular-progress-bar.component.html',
  styleUrls: ['./circular-progress-bar.component.scss']
})
export class CircularProgressBarComponent implements OnInit {
  @Input() percentage: number = 0;
  @Input() size: number = 60; // diameter in pixels
  @Input() strokeWidth: number = 6;
  @Input() showPercentageText: boolean = true;
  @Input() colorScheme: 'default' | 'success' | 'warning' | 'danger' | 'info' = 'default';

  // Computed properties
  radius: number = 0;
  circumference: number = 0;
  strokeDashoffset: number = 0;
  color: string = '';

  ngOnInit() {
    this.calculateCircle();
    this.setColor();
  }

  ngOnChanges() {
    this.calculateCircle();
    this.setColor();
  }

  private calculateCircle() {
    // Ensure percentage is between 0 and 100
    this.percentage = Math.min(Math.max(this.percentage, 0), 100);
    
    // Calculate radius (accounting for stroke width)
    this.radius = (this.size - this.strokeWidth) / 2;
    
    // Calculate circumference
    this.circumference = 2 * Math.PI * this.radius;
    
    // Calculate stroke-dashoffset for progress
    this.strokeDashoffset = this.circumference - (this.percentage / 100) * this.circumference;
  }

  private setColor() {
    if (this.colorScheme === 'default') {
      // Auto-determine color based on percentage
      if (this.percentage > 90) {
        this.color = '#28a745';
      } else if (this.percentage > 69 && this.percentage < 90) {
        this.color = '#a4e795';
      } 
        else if (this.percentage > 59 && this.percentage < 69) {
        this.color = '#ffc107';
      } else if (this.percentage > 39 && this.percentage < 59) {
        this.color = '#e9ca93';
      } else if (this.percentage > 19 && this.percentage < 39) {
        this.color = '#f1a8a8';
      } else if (this.percentage < 19) {
        this.color = '#6c757d'; 
      } else {
        this.color = '#6c757d'; 
      }
    } else {
      // Use predefined color scheme
      const colorMap = {
        success: '#28a745',
        warning: '#ffc107',
        danger: '#dc3545',
        info: '#17a2b8'
      };
      this.color = colorMap[this.colorScheme] || '#6c757d';
    }
  }
}



